import script from "./CampoObservacao.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoObservacao.vue?vue&type=script&setup=true&lang=js"

import "./CampoObservacao.vue?vue&type=style&index=0&id=d9b35a1c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9b35a1c"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
